"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagList = void 0;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const mithril_component_1 = require("../../components/mithril.component");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const dom_1 = require("../../dom");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const tag_state_1 = require("../../page/tag.state");
const services_1 = require("../../services");
const page_state_1 = require("../../state/page.state");
const tag_sort_state_1 = require("../../state/tag.sort.state");
const store_1 = require("../../store");
const collection_list_1 = require("../collection.list/collection.list");
const collection_toolbar_1 = require("../collection.toolbar/collection.toolbar");
const tag_card_1 = require("./tag.card");
const tag_list_style_1 = require("./tag.list.style");
(0, theme_1.addStyles)(tag_list_style_1.Style);
const CONTENT_KEY = 'tag-list';
class TagList extends mithril_component_1.IMithrilComponent {
    constructor(state) {
        super();
        this.tagCards = {};
        this.state = state;
        this.toolbar = new collection_toolbar_1.CollectionToolbar(this.state, {
            title: i18n_1.T.TAG_TITLE,
        });
    }
    onRemove() {
        this.tagCards = {};
    }
    get nodes() {
        const visibleTags = this.state.visibleTags;
        let content;
        if (visibleTags.length !== 0) {
            const cardChildren = [];
            for (const tag of visibleTags) {
                let tagCard = this.tagCards[tag.objectId];
                if (tagCard == null) {
                    tagCard = this.tagCards[tag.objectId] = new tag_card_1.TagCard(this.state, tag);
                }
                cardChildren.push(tagCard.view());
                let child = null;
                if (page_state_1.CurrentState.expandedTagId === tag.objectId) {
                    child = this.viewExpandedTag();
                }
                else if (services_1.Services.Search.filterState.hasFilter() &&
                    services_1.Services.Search.collectionSummaries[tag.objectId] != null) {
                    child = this.viewFilteredCollectionList(tag);
                }
                if (child != null) {
                    cardChildren.push(child);
                }
            }
            if (this.state.hasMore) {
                cardChildren.push(this.loadMoreButton());
            }
            content = (0, mithril_1.m)('div', { className: tag_list_style_1.CSS.cards.container }, cardChildren);
        }
        else if (this.state.fetchState === tag_state_1.TagFetchState.UNKNOWN) {
            content = this.viewLoadingResult();
        }
        else if (this.state.fetchState !== tag_state_1.TagFetchState.HAS_TAGS) {
            content = this.viewEmptyResult();
        }
        else {
            content = this.viewSearchEmptyResult();
        }
        content.attrs.key = CONTENT_KEY;
        return (0, mithril_1.m)('div', { className: tag_list_style_1.CSS.container, onmousemove: dom_1.handleMouseMove }, [this.toolbar.view(), content]);
    }
    loadMoreButton() {
        return (0, mithril_1.m)('div', { key: 'load-more', className: tag_list_style_1.CSS.loadmore }, (0, mithril_1.m)('button', { className: 'mdl-button', onclick: this.state.loadMore }, (0, i18n_1.Translate)(i18n_1.T.LOAD_MORE)));
    }
    get expandedCollections() {
        const tagSummary = store_1.AppStore.TagSummary.get(page_state_1.CurrentState.expandedTagId);
        if (tagSummary == null) {
            return null;
        }
        const collectionSummaries = [];
        for (const revision of tagSummary.revisions) {
            const collectionSummary = store_1.AppStore.CollectionSummary.get(revision);
            if (collectionSummary != null) {
                collectionSummaries.push(collectionSummary);
            }
        }
        if (collectionSummaries.length !== tagSummary.revisions.length) {
            return null;
        }
        tag_sort_state_1.TagSortState.sortSummaries(collectionSummaries);
        page_state_1.CurrentState.Tag.resetLastSelectedCollectionIndex();
        page_state_1.CurrentState.Tag.setExpandedCollectionsUUIDs(collectionSummaries.map((_) => _.uuid));
        return collectionSummaries;
    }
    viewExpandedTag() {
        if (page_state_1.CurrentState.expandedTagId == null) {
            return null;
        }
        const summaries = this.expandedCollections;
        if (summaries === null) {
            return collection_list_1.CollectionList.viewLoading(page_state_1.CurrentState.expandedTagId);
        }
        const tag = store_1.AppStore.Tag.get(page_state_1.CurrentState.expandedTagId);
        return collection_list_1.CollectionList.view(this.state, tag, this.expandedCollections);
    }
    viewFilteredCollectionList(tag) {
        const collectionSummaries = services_1.Services.Search.collectionSummaries[tag.objectId];
        return collection_list_1.CollectionList.view(this.state, tag, collectionSummaries);
    }
    viewEmptyResult() {
        return (0, mithril_1.m)('div', { className: `${tag_list_style_1.CSS.cards.container} ${tag_list_style_1.CSS.cards.isEmpty}` }, [
            (0, mithril_1.m)('div', { className: tag_list_style_1.CSS.empty.message, key: `${CONTENT_KEY}-empty-message` }, (0, i18n_1.Translate)(i18n_1.T.TAG_FILTER__SEARCH_EMPTY)),
        ]);
    }
    viewLoadingResult() {
        return (0, mithril_1.m)('div', { className: `${tag_list_style_1.CSS.cards.container} ${tag_list_style_1.CSS.cards.isEmpty}` }, spinner_1.Spinner.view());
    }
    viewSearchEmptyResult() {
        return (0, mithril_1.m)('div', { className: `${tag_list_style_1.CSS.cards.container} ${tag_list_style_1.CSS.cards.isEmpty}` }, [
            (0, mithril_1.m)('div', { className: tag_list_style_1.CSS.empty.message, key: `${CONTENT_KEY}-empty-message` }, (0, i18n_1.Translate)(i18n_1.T.TAG_FILTER__SEARCH_EMPTY)),
            (0, mithril_1.m)('button', {
                key: `${CONTENT_KEY}-clear-search`,
                className: `mdl-button ${tag_list_style_1.CSS.empty.reset}`,
                onclick: () => services_1.Services.Search.reset(),
            }, (0, i18n_1.Translate)(i18n_1.T.CLEAR_SEARCH)),
        ]);
    }
}
exports.TagList = TagList;
tslib_1.__decorate([
    mobx_1.computed
], TagList.prototype, "expandedCollections", null);
//# sourceMappingURL=tag.list.js.map